"use strict";const r=require("react/jsx-runtime"),o=require("./createSvgIcon-b2c02d98.js"),e=o.createSvgIcon(r.jsx("path",{d:"m7 10 5 5 5-5z"}),"ArrowDropDown");exports.ArrowDropDown=e;
